import { useMemo } from "react";
import { useMediaQuery } from "react-responsive";

const BREAKPOINTS = {
  xxs: 400,
  xs: 600,
  sm: 800,
  md: 1000,
  lg: 1200,
  xl: 1500,
  xxl: 1800,
};

const useResponsive = () => {
  const mediaMaxXxs = useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.xxs - 0.02}px)`,
  });
  const mediaMaxXs = useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.xs - 0.02}px)`,
  });
  const mediaMaxSm = useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.sm - 0.02}px)`,
  });
  const mediaMaxMd = useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.md - 0.02}px)`,
  });
  const mediaMaxLg = useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.lg - 0.02}px)`,
  });
  const mediaMaxXl = useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.xl - 0.02}px)`,
  });
  const mediaMaxXxl = useMediaQuery({
    query: `(max-width: ${BREAKPOINTS.xxl - 0.02}px)`,
  });

  const mediaMinXxs = useMediaQuery({
    query: `(min-width: ${BREAKPOINTS.xxs}px)`,
  });
  const mediaMinXs = useMediaQuery({
    query: `(min-width: ${BREAKPOINTS.xs}px)`,
  });
  const mediaMinSm = useMediaQuery({
    query: `(min-width: ${BREAKPOINTS.sm}px)`,
  });
  const mediaMinMd = useMediaQuery({
    query: `(min-width: ${BREAKPOINTS.md}px)`,
  });
  const mediaMinLg = useMediaQuery({
    query: `(min-width: ${BREAKPOINTS.lg}px)`,
  });
  const mediaMinXl = useMediaQuery({
    query: `(min-width: ${BREAKPOINTS.xl}px)`,
  });
  const mediaMinXxl = useMediaQuery({
    query: `(min-width: ${BREAKPOINTS.xxl}px)`,
  });

  const max = useMemo(
    () => ({
      xxs: mediaMaxXxs,
      xs: mediaMaxXs,
      sm: mediaMaxSm,
      md: mediaMaxMd,
      lg: mediaMaxLg,
      xl: mediaMaxXl,
      xxl: mediaMaxXxl,
    }),
    [
      mediaMaxXxs,
      mediaMaxXs,
      mediaMaxSm,
      mediaMaxMd,
      mediaMaxLg,
      mediaMaxXl,
      mediaMaxXxl,
    ],
  );

  const min = useMemo(
    () => ({
      xxs: mediaMinXxs,
      xs: mediaMinXs,
      sm: mediaMinSm,
      md: mediaMinMd,
      lg: mediaMinLg,
      xl: mediaMinXl,
      xxl: mediaMinXxl,
    }),
    [
      mediaMinXxs,
      mediaMinXs,
      mediaMinSm,
      mediaMinMd,
      mediaMinLg,
      mediaMinXl,
      mediaMinXxl,
    ],
  );

  return { max, min };
};

export default useResponsive;
